module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_engl_primærlogo_sentrert_logo_pos.8bd70c5d.svg";